export default __webpack_public_path__ + "static/media/025-game controller.ce39edd7.svg";